import * as React from 'react';
import Slider from 'react-slick';
import { useTheme } from '../../../theme';
const ImagesSlider = ({ images }) => {
    const theme = useTheme('EveryPortCard').EveryPortCard;
    return (React.createElement(Slider, { arrows: true, dots: true, className: theme.slider, autoplay: true }, images.map((image, key) => {
        return (React.createElement("div", { className: theme.image, key: key },
            React.createElement("div", { className: theme.image__thumb, style: { backgroundImage: `url(${image})` } })));
    })));
};
export default ImagesSlider;
